import React from 'react';
import logo from '../assets/isobar-logo-white.png';

export default (props) => (
  <footer>
    <img className="logo" src={logo} alt="Isobar logo" />
  </footer>
);
